
import { Component, Prop, Vue } from "nuxt-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";

@Component({
  components: {
    RouterLink,
    PlaceHolderCircles: () =>
      import("~/components/molecules/display/PlaceHolderCircles.vue"),
  },
})
export default class PlaceList extends Vue {
  @Prop() items: Array<{
    name: string;
    link?: { title: string; path: string };
  }>;
  @Prop() exceeded: boolean;
}
